import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios';
import Cookies from 'js-cookie';

const initialState = {
    orgId: Cookies.get("orgId"),
    isLoading: false,
    userData: Cookies.get('userData') ? JSON.parse(Cookies.get('userData')) : { userId: "", userInfo: {} }
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setOrgId: (state, action) => {
            state.orgId = action.payload;
            Cookies.set("orgId", action.payload)
        },
        setLoader: (state, action) => {
            state.isLoading = action.payload;
        },
        setUserDetails: (state, action) => {
            state.userData = action.payload;
        },
        signout: (state) => {
            state.userData = {};
            Cookies.remove('userData');
            Cookies.remove('orgId');
        }

    },
})
// Action creators are generated for each case reducer function
export const { setOrgId, setLoader, signout, setUserDetails } = userSlice.actions;

export const getUserDetails = (userId, orgId) => (dispatch) => {
    let url = "http://18.132.190.48:8080/api/v1/";
    dispatch(setLoader(true));
    const params = {
        userId,
        orgId
    }
    return axios
        .get(`${url}getUserDetails`, { params })
        .then((res) => {
            const detail = {
                userInfo: res.data,
                userId
            }

            dispatch(setUserDetails(detail));
            Cookies.set('userData', JSON.stringify(detail));
            dispatch(setLoader(false));
        })
        .catch((err) => {
            dispatch(setLoader(false));
        })

}


export default userSlice.reducer;